import { IUploadProgress, UploadStatus } from './file-upload.types';

export const cancelAll = (uploadProgress: IUploadProgress[]) => {
  uploadProgress.forEach((_, index) => {
    cancelUpload(uploadProgress, index);
  });
};

export const cancelUpload = (uploadProgress: IUploadProgress[], index: number) => {
  uploadProgress[index].status = UploadStatus.CANCELLED;
  //uploadProgress[index].subscription?.unsubscribe();
};
